export default __webpack_public_path__ + "static/media/plant-hand-icon.4fa670a7.svg";